import styled from '@emotion/styled';

export const List = styled.div(({ theme }) => ({
  border: `1px solid ${theme.color.divider}`,
  borderRadius: 8,
  padding: '0 16px',
}));
